import React from 'react'

function ShowLadderIncentive() {
  return (
    <div>ShowLadderIncentive</div>
  )
}

export default ShowLadderIncentive